import { toaster } from "@pathwright/ux/src/components/chakra/ui/toaster"
import { useEffect, useRef } from "react"

const PopupAlert = ({
  success,
  error,
  info,
  loading,
  description,
  onClear,
  children,
  inverted,
  clearAfter = 5000,
  dismissOnUnmount = false
}) => {
  const toastIdRef = useRef()

  const errorMessage =
    typeof error === "string" ? error : error?.message || error?.toString()

  useEffect(() => {
    const toastOptions = {
      type: success
        ? "success"
        : errorMessage
        ? "error"
        : info
        ? "info"
        : loading
        ? "loading"
        : "info",
      duration: clearAfter,
      closable: true,
      title:
        success ||
        errorMessage ||
        info ||
        children ||
        (loading && (loading?.title || "Loading...")) ||
        null,
      description: description || loading?.description || null,
      // Prevent the toast from potentially being re-triggered
      onCloseComplete: () => {
        toastIdRef.current = null
        onClear?.()
      }
    }

    // Show a new toast if needed, or update the current one.
    if (success || errorMessage || info || loading) {
      if (toastIdRef.current) {
        toaster.update(toastIdRef.current, toastOptions)
      } else {
        toastIdRef.current = toaster.create(toastOptions)
      }
    }
  }, [
    success,
    errorMessage,
    info,
    loading,
    description,
    children,
    inverted,
    clearAfter,
    onClear
  ])

  useEffect(
    () => () => {
      if (dismissOnUnmount && toastIdRef.current) {
        toaster.dismiss(toastIdRef.current)
        toastIdRef.current = null
      }
    },
    [dismissOnUnmount]
  )

  return null
}

export default PopupAlert
